import React, { useEffect, useState, useCallback } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

import RouteTracker from "./RouteTracker";

// Routes
import Home2 from "./routes/newRoutes/Home2";
import GameDetails2 from "./routes/newRoutes/GameDetails2";
import AllQuizes2 from "./routes/newRoutes/AllQuizes2";
import Leaderboard2 from "./routes/newRoutes/Leaderboard2";
import Login2 from "./routes/newRoutes/Login2";
import Signup2 from "./routes/newRoutes/Signup2";
import Account2 from "./routes/newRoutes/Account2";
import History2 from "./routes/newRoutes/History2";
import FindingOpponent2 from "./routes/newRoutes/FindingOpponent2";
import GamePlayDashboard2 from "./routes/newRoutes/GamePlayDashboard2";
import GameResults2 from "./routes/newRoutes/GameResults2";
import NoQuestionsFound2 from "./routes/newRoutes/NoQuestionsFound2";
import History3 from "./routes/newRoutes/History3";
import ErrorBoundary from "./components/newComponents/ErrorBoundary";
import PageNotFound from "./routes/newRoutes/PageNotFound";
import Subscribe from "./components/Subscribe";
import OtpVerification from "./components/Otp";
import OtpVerify from "./components/VerifyOtp";
import Redirect from "./components/Redirect";
import Deactivation from "./components/Deactivation";
import PromoRedirectPage from "./components/PromoRedirectPage";

// APIs
const loginUserApi = "/loginuser";
const headerApi = "/header";

// Protected route wrapper
const ProtectedRoute = ({ element, status }) => {
  return status === 1 ? element : <Navigate to="/subscribe" />;
};

const App = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    const msisdn = Cookies.get("msisdn");
    if (msisdn) {
      try {
        const res = await axios.get(`${loginUserApi}?msisdn=${msisdn}`);
        setStatus(res?.data?.status || 0);
      } catch {
        setStatus(0);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const res = await axios.get(headerApi);
        if (res?.data?.status === 1 && res?.data?.msisdn) {
          Cookies.set("msisdn", res.data.msisdn);
          setStatus(1);
        } else {
          setStatus(0);
        }
      } catch {
        setStatus(0);
      } finally {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  const handlePathChange = (prevPath) => {
    const currentPath = window.location.pathname;
    if (prevPath === "/otp-validation" && currentPath === "/") {
      fetchStatus();
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <RouteTracker onPathChange={handlePathChange}>
      <Routes>
        <Route path="/" element={<Home2 status={status} />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/otp" element={<OtpVerification />} />
        <Route path="/otp-validation" element={<OtpVerify />} />
        <Route path="/redirect" element={<Redirect status={status}  />} />
        <Route path="/deactivation" element={<Deactivation />} />
        <Route path="/promo" element={<PromoRedirectPage />} />


        <Route path="/all-quizes" element={<ProtectedRoute status={status} element={<AllQuizes2  status={status} />} />} />
        <Route path="/leaderboard" element={<ProtectedRoute  status={status}  element={<Leaderboard2 status={status} />} />} />
        <Route path="/login" element={<ProtectedRoute status={status} element={<Login2  status={status} />} />} />
        <Route path="/signup" element={<ProtectedRoute status={status} element={<Signup2  status={status} />} />} />
        <Route path="/account" element={<ProtectedRoute status={status} element={<Account2  status={status}/>} />} />
        <Route path="/game/details/:category/:categoryId" element={<ProtectedRoute status={status} element={<GameDetails2  status={status} />} />} />
        <Route path="/game/:category/:categoryId/search/opponent/:mode/:modePoint" element={<ProtectedRoute status={status} element={<FindingOpponent2  status={status}/>} />} />
        <Route path="/game/:category/:categoryId/play/:mode/:modePoint" element={<ProtectedRoute status={status} element={<GamePlayDashboard2  status={status}/>} />} />
        <Route path="/game/:category/:categoryId/:mode/results" element={<ProtectedRoute status={status} element={<GameResults2  status={status} />} />} />
        <Route path="/oops" element={<ProtectedRoute status={status} element={<NoQuestionsFound2  status={status}/>} />} />
        <Route path="/history" element={<ProtectedRoute status={status} element={<History3  status={status} />} />} />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </RouteTracker>
  );
};

export default App;





// import React, { useEffect, useState } from "react";
// import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
// import axios from "axios";
// import Cookies from "js-cookie";

// import Home2 from "./routes/newRoutes/Home2";
// import GameDetails2 from "./routes/newRoutes/GameDetails2";
// import AllQuizes2 from "./routes/newRoutes/AllQuizes2";
// import Leaderboard2 from "./routes/newRoutes/Leaderboard2";
// import Login2 from "./routes/newRoutes/Login2";
// import Signup2 from "./routes/newRoutes/Signup2";
// import Account2 from "./routes/newRoutes/Account2";
// import History2 from "./routes/newRoutes/History2";
// import FindingOpponent2 from "./routes/newRoutes/FindingOpponent2";
// import GamePlayDashboard2 from "./routes/newRoutes/GamePlayDashboard2";
// import GameResults2 from "./routes/newRoutes/GameResults2";
// import NoQuestionsFound2 from "./routes/newRoutes/NoQuestionsFound2";
// import History3 from "./routes/newRoutes/History3";
// import ErrorBoundary from "./components/newComponents/ErrorBoundary";
// import PageNotFound from "./routes/newRoutes/PageNotFound";
// import Subscribe from "./components/Subscribe";
// import OtpVerification from "./components/Otp";
// import OtpVerify from "./components/VerifyOtp";
// import Redirect from "./components/Redirect";
// import Deactivation from "./components/Deactivation";

// const loginUserApi = '/loginuser';
// const headerApi = '/header';

// const ProtectedRoute = ({ element, status }) => {
//   return status === 1 ? element : <Navigate to="/subscribe" />;
// };

// const App = () => {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const msisdn = Cookies.get("msisdn");
//     console.log("MSISDN IN COOKIES",msisdn)
//     if (msisdn) {
//       axios
//         .get(`${loginUserApi}?msisdn=${msisdn}`)
//         .then((res) => {
//           console.log("RES",res)
//           setStatus(res?.data?.status || 0);
//         })
//         .catch(() => {
//           setStatus(0);
//         })
//         .finally(() => setLoading(false));
//     } 
//     else {
//   axios
//     .get(headerApi)
//     .then((res) => {
//       const result = res?.data;
//       if (result?.status == 1 && result?.msisdn) {
//         Cookies.set("msisdn", result.msisdn);
//         setStatus(1);
//       } else {
//         setStatus(0);
//       }
//     })
//     .catch(() => {
//       setStatus(0);
//     })
//     .finally(() => setLoading(false));
// }

//     // else {
//     //   axios
//     //     .get(headerApi)
//     //     .then((res) => {
//     //       setStatus(res?.data?.status || 0);
//     //     })
//     //     .catch(() => {
//     //       setStatus(0);
//     //     })
//     //     .finally(() => setLoading(false));
//     // }
//   }, []);

//   if (loading) return <div>Loading...</div>;

//   const router = createBrowserRouter([
//     { path: "/", element: <Home2 status={status} />, errorElement: <ErrorBoundary /> },
//     { path: "/subscribe", element: <Subscribe />, errorElement: <ErrorBoundary /> },
//     { path: "/otp", element: <OtpVerification />, errorElement: <ErrorBoundary /> },
//     { path: "/otp-validation", element: <OtpVerify />, errorElement: <ErrorBoundary /> },
//     {path: "/redirect", element: <Redirect />, errorElement: <ErrorBoundary />},
//     { path: "/deactivation", element: <Deactivation  />, errorElement: <ErrorBoundary /> },
//     // Protected routes
//     {
//       path: "/all-quizes",
//       element: <ProtectedRoute status={status} element={<AllQuizes2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/leaderboard",
//       element: <ProtectedRoute status={status} element={<Leaderboard2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/login",
//       element: <ProtectedRoute status={status} element={<Login2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/signup",
//       element: <ProtectedRoute status={status} element={<Signup2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/account",
//       element: <ProtectedRoute status={status} element={<Account2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/details/:category/:categoryId",
//       element: <ProtectedRoute status={status} element={<GameDetails2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/search/opponent/:mode/:modePoint",
//       element: <ProtectedRoute status={status} element={<FindingOpponent2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/play/:mode/:modePoint",
//       element: <ProtectedRoute status={status} element={<GamePlayDashboard2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/:mode/results",
//       element: <ProtectedRoute status={status} element={<GameResults2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/oops",
//       element: <ProtectedRoute status={status} element={<NoQuestionsFound2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/history",
//       element: <ProtectedRoute status={status} element={<History3 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "*",
//       element: <PageNotFound />,
//       errorElement: <ErrorBoundary />,
//     },
//   ]);

//   return <RouterProvider router={router} />;
// };

// export default App;




// import React, { useEffect, useState } from "react";
// import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
// import axios from "axios";

// import Home2 from "./routes/newRoutes/Home2";
// import GameDetails2 from "./routes/newRoutes/GameDetails2";
// import AllQuizes2 from "./routes/newRoutes/AllQuizes2";
// import Leaderboard2 from "./routes/newRoutes/Leaderboard2";
// import Login2 from "./routes/newRoutes/Login2";
// import Signup2 from "./routes/newRoutes/Signup2";
// import Account2 from "./routes/newRoutes/Account2";
// import History2 from "./routes/newRoutes/History2";
// import FindingOpponent2 from "./routes/newRoutes/FindingOpponent2";
// import GamePlayDashboard2 from "./routes/newRoutes/GamePlayDashboard2";
// import GameResults2 from "./routes/newRoutes/GameResults2";
// import NoQuestionsFound2 from "./routes/newRoutes/NoQuestionsFound2";
// import History3 from "./routes/newRoutes/History3";
// import ErrorBoundary from "./components/newComponents/ErrorBoundary";
// import PageNotFound from "./routes/newRoutes/PageNotFound";
// import Subscribe from "./components/Subscribe";
// import OtpVerification from "./components/Otp";
// import OtpVerify from "./components/VerifyOtp";
// import Cookies from 'js-cookie'
// const loginUser='http://localhost:3487/loginuser'
// const ProtectedRoute = ({ element, status }) => {
//   if (status === 1) return element;
//   return <Navigate to="/subscribe" />;
// };

// const App = () => {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     axios.get("/header")
//       .then((res) => {
//         setStatus(res.data?.status);
//       })
//       .catch(() => {
//         setStatus(0);
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) return <div>Loading...</div>;

//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element:<Home2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/subscribe",
//       element: <Subscribe />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/otp",
//       element: <OtpVerification />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/otp-validation",
//       element: <OtpVerify />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/all-quizes",
//       element: <ProtectedRoute status={status} element={<AllQuizes2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/leaderboard",
//       element: <ProtectedRoute status={status} element={<Leaderboard2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/login",
//       element: <ProtectedRoute status={status} element={<Login2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/signup",
//       element: <ProtectedRoute status={status} element={<Signup2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/account",
//       element: <ProtectedRoute status={status} element={<Account2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/details/:category/:categoryId",
//       element: <ProtectedRoute status={status} element={<GameDetails2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/search/opponent/:mode/:modePoint",
//       element: <ProtectedRoute status={status} element={<FindingOpponent2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/play/:mode/:modePoint",
//       element: <ProtectedRoute status={status} element={<GamePlayDashboard2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/:mode/results",
//       element: <ProtectedRoute status={status} element={<GameResults2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/oops",
//       element: <ProtectedRoute status={status} element={<NoQuestionsFound2 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/history",
//       element: <ProtectedRoute status={status} element={<History3 />} />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "*",
//       element: <PageNotFound />,
//       errorElement: <ErrorBoundary />,
//     },
//   ]);

//   return <RouterProvider router={router} />;
// };

// export default App;



// import React from "react";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import Home2 from "./routes/newRoutes/Home2";
// import GameDetails2 from "./routes/newRoutes/GameDetails2";
// import AllQuizes2 from "./routes/newRoutes/AllQuizes2";
// import Leaderboard2 from "./routes/newRoutes/Leaderboard2";
// import Login2 from "./routes/newRoutes/Login2";
// import Signup2 from "./routes/newRoutes/Signup2";
// import Account2 from "./routes/newRoutes/Account2";
// import History2 from "./routes/newRoutes/History2";
// import FindingOpponent2 from "./routes/newRoutes/FindingOpponent2";
// import GamePlayDashboard2 from "./routes/newRoutes/GamePlayDashboard2";
// import GameResults2 from "./routes/newRoutes/GameResults2";
// import NoQuestionsFound2 from "./routes/newRoutes/NoQuestionsFound2";
// import History3 from "./routes/newRoutes/History3";
// import ErrorBoundary from "./components/newComponents/ErrorBoundary";
// import PageNotFound from "./routes/newRoutes/PageNotFound";
// import Subscribe from "./components/Subscribe";
// import OtpVerification from "./components/Otp";
// import OtpVerify from "./components/VerifyOtp";

// const App = () => {
//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element: <Home2 />,
//       errorElement: <ErrorBoundary />,
//     },

//       {
//       path: "/subscribe",
//       element: <Subscribe />,
//       errorElement: <ErrorBoundary />,
//     },
//      {
//       path: "/otp",
//       element: <OtpVerification/>,
//       errorElement: <ErrorBoundary />,
//     },
//      {
//       path: "/otp-validation",
//       element: <OtpVerify/>,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/all-quizes",
//       element: <AllQuizes2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/leaderboard",
//       element: <Leaderboard2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/login",
//       element: <Login2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/signup",
//       element: <Signup2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/account",
//       element: <Account2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/details/:category/:categoryId",
//       element: <GameDetails2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/search/opponent/:mode/:modePoint",
//       element: <FindingOpponent2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/play/:mode/:modePoint",
//       element: <GamePlayDashboard2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/game/:category/:categoryId/:mode/results",
//       element: <GameResults2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/oops",
//       element: <NoQuestionsFound2 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "/history",
//       element: <History3 />,
//       errorElement: <ErrorBoundary />,
//     },
//     {
//       path: "*",
//       element: <PageNotFound />,
//       errorElement: <ErrorBoundary />,
//     },
//   ]);
//   return (
//     <>
//       <RouterProvider router={router} />
//     </>
//   );
// };

// export default App;
